/**
 * @file HeightScheme.tsx
 * @description Мини-схемы режимов высоты для карточек `HeightModeField`
 * (phase19.16, партия SB120, этап 1; SB122 — «схемы вместо слов»;
 * uiux-sb120-stage1 «Дополнение» §2.1): «▭ Aa» по содержимому, «▣» по фото,
 * «▭ 600» числом, «▯» экран. Только картинка: подпись — у карточки.
 */

import type { HeightKind } from "../../../../lib/site-builder/look-size";

export function HeightScheme({ kind }: { kind: HeightKind }) {
  switch (kind) {
    case "content":
      return (
        <span className="flex h-6 w-12 items-center justify-center rounded-sm border border-primary/60 text-xs font-semibold text-primary">
          Aa
        </span>
      );
    case "photo":
      return <span className="block h-7 w-12 rounded-sm bg-primary/60" />;
    case "number":
      return (
        <span className="flex h-8 w-12 items-center justify-center rounded-sm border border-primary/60 text-xs font-semibold tabular-nums text-primary">
          600
        </span>
      );
    case "screen":
      return <span className="block h-10 w-7 rounded-sm border-2 border-primary/60" />;
  }
}
